export const MemberNameField = ({ data }: { data: any }) => {
    const profileData = data;
    return (
        <span>
            {profileData.firstName} {profileData.lastName}
        </span>
    );
};
